import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import { FilterHeader } from "@shared/table/headers/FilterHeader";
import { ColumnFiltersState } from "@tanstack/react-table";

type Props = {
    organizationNames: string[];
    columnFilters: ColumnFiltersState;
    setColumnFilters: Dispatch<SetStateAction<ColumnFiltersState>>;
};

export const PublishedByHeader = ({ organizationNames, columnFilters, setColumnFilters }: Props) => {
    const { t } = useTranslation(["modals"]);
    const options = [...new Set(organizationNames)].map((name) => ({ key: name, label: name }));
    const current =
        (columnFilters.find((columnFilter) => columnFilter.id === "organizationName")?.value as string[] | undefined) ?? [];

    return (
        <FilterHeader
            title={t("modals:filterDialog.variants.publishedBy")}
            options={options}
            initialValues={Object.fromEntries(options.map((option) => [option.key, current.includes(option.key)]))}
            onSubmit={(values) => {
                const selectedKeys = Object.keys(values).filter((optionKey) => values[optionKey]);
                setColumnFilters((previousFilters) => {
                    const remainingFilters = previousFilters.filter((columnFilter) => columnFilter.id !== "organizationName");
                    return selectedKeys.length
                        ? [{ id: "organizationName", value: selectedKeys }, ...remainingFilters]
                        : remainingFilters;
                });
            }}
        />
    );
};
